import React from "react";
import lottie from "lottie-web";
import contact from "../assets/animations/contact.json";
import "./Section.css";

export default function Contact() {
  React.useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector("#contact-animation"),
      animationData: contact,
    });
  }, []);
  return (
    <div
      id="contact"
      className="main"
      style={{ background: "#EEF9ED", color: "black", zIndex: 100 }}
    >
      <div id="contact-animation" style={{ width: "50%", height: "50%" }} />
      <div className="text" style={{ marginLeft: "2%" }}>
        <h1 style={{ fontWeight: 800, fontSize: "4rem", marginBottom: "-3%" }}>
          Get in touch!
        </h1>
        <h3 style={{ fontWeight: 400 }}>
          Email:{" "}
          <a href="mailto:printmate21@gmail.com">printmate21@gmail.com</a>
        </h3>
        <h3 style={{ fontWeight: 400 }}>
          Telephone: <a href="tel:+1-123-456-7890">+1-416-998-3461</a>
        </h3>
      </div>
    </div>
  );
}
